export default __webpack_public_path__ + "static/media/lampstyle-bg-gray.6afb7859.svg";